define('benefit', ['jquery'], function ($) {
    return {
        init: function init() {
            $(document).ready(function() {
                if(!$('.benefit-section-3').length) {
                    return;
                }

                var sliderConfig = window.benefits.slider;
                var sliderItemsLength = jQuery('.benefit-section-3 .benefit__wrapper').length;

                $.each(sliderConfig, function (key, value) {
                    if(value > sliderItemsLength) {
                        sliderConfig[''+key+''] = sliderItemsLength;
                    }
                })

                $('.benefit-section-3').slick({
                    infinite: true,
                    dots: false,
                    slidesToShow: sliderConfig.fullhd,
                    slidesToScroll: 1,
                    arrows: true,
                    prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" role="button" style="display: flex;"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24"><defs><path id="icons-default-arrow-head-left" d="m12.5 7.9142 10.2929 10.293c.3905.3904 1.0237.3904 1.4142 0 .3905-.3906.3905-1.0238 0-1.4143l-11-11c-.3905-.3905-1.0237-.3905-1.4142 0l-11 11c-.3905.3905-.3905 1.0237 0 1.4142.3905.3905 1.0237.3905 1.4142 0L12.5 7.9142z"></path></defs><use transform="matrix(0 1 1 0 .5 -.5)" xlink:href="#icons-default-arrow-head-left" fill="#758CA3" fill-rule="evenodd"></use></svg></button>',
                    nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" role="button" style="display: flex;"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24"><defs><path id="icons-default-arrow-head-right" d="m11.5 7.9142 10.2929 10.293c.3905.3904 1.0237.3904 1.4142 0 .3905-.3906.3905-1.0238 0-1.4143l-11-11c-.3905-.3905-1.0237-.3905-1.4142 0l-11 11c-.3905.3905-.3905 1.0237 0 1.4142.3905.3905 1.0237.3905 1.4142 0L11.5 7.9142z"></path></defs><use transform="rotate(90 11.5 12)" xlink:href="#icons-default-arrow-head-right" fill="#758CA3" fill-rule="evenodd"></use></svg></button>',
                    // autoplay: true,
                    autoplaySpeed: 500,
                    speed: 100,
                    focusOnSelect: false,
                    responsive: [
                        {
                            breakpoint: 1200,
                            settings: {
                                slidesToShow: sliderConfig.hd,
                            }
                        },
                        {
                            breakpoint: 900,
                            settings: {
                                slidesToShow: sliderConfig.fullsd
                            }
                        },
                        {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: sliderConfig.sd,
                                arrows: false
                            }
                        }
                    ]
                }).on('setPosition', function (event, slick) {
                    slick.$slides.css('height', slick.$slideTrack.height() + 'px');
                });
            });

            $('.benefit-section-3').on('init', function (event, slick) {
                $(this).find('.benefit__content').addClass('height-auto');
                var contents = $(this).find('.benefit__content .text'), maxHeightContent = 0;
                if(contents.length) {
                    contents.each(function () {
                        if(maxHeightContent < $(this).height()) {
                            maxHeightContent = $(this).height();
                        }

                    })
                }
                if(maxHeightContent) {
                    $('.benefit-section-3 .benefit__content .text').height(maxHeightContent);
                }
            });
        }
    };
});

